export default __webpack_public_path__ + "static/media/010-Pointer.05c2345e.svg";